exports.BBB_LINK =
  'https://www.bbb.org/us/fl/spring-hill/profile/health-insurance/usa-benefits-group-0653-90354849'

exports.PDF_LOGO_SVG = 'static/icn.pdf.svg'
